import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import UserLink from '../../../User/Link';
import BasicUserName from '../../../User/BasicUserName';
class MentionComponent extends React.Component {
    render() {
        if (!this.props || !this.props.componentData) {
            return null;
        }
        const { componentData: { mention  } , children  } = this.props;
        if (!mention || !mention.name) {
            return null;
        }
        // The renderer will pass in children we need to wrap our outer
        // with the styled child...
        let wrapStyles = {};
        if (children[1]) {
            wrapStyles = children[1].props.style;
        }
        if (mention.type) {
            const user = {
                type: mention.type || 'standard',
                username: mention.name,
                userId: mention.userId || 0,
                useridUuid: mention.userUuid || '',
                usericon: mention.avatar,
                isNewDeviant: false
            };
            return /*#__PURE__*/ React.createElement("span", {
                style: _object_spread({}, this.props.style, wrapStyles),
                className: this.props.className
            }, /*#__PURE__*/ React.createElement(UserLink, {
                key: mention.name,
                user: user,
                withTooltip: false,
                className: "editor-mention-link"
            }, mention.name.length > 0 && mention.name[0] !== '@' && /*#__PURE__*/ React.createElement("span", {
                className: "editor-mention-prefix"
            }, "@"), /*#__PURE__*/ React.createElement(BasicUserName, {
                user: user
            })));
        }
        // Fallback when we dont have enough info for user
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("a", {
            style: _object_spread({}, this.props.style, wrapStyles),
            className: this.props.className,
            href: `https://www.deviantart.com/${mention.name.toLowerCase().replace(/^@/, '')}`,
            title: mention.name
        }, `${mention.name}`));
    }
}
export default MentionComponent;
